import { useQuery } from "@tanstack/react-query";
import { fetchTargetCategoriesWithPupils } from "api/categories/fetchTargetCategoriesWithPupils";

export function useFetchTargetCategories() {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["categories/target-with-pupils"],
        queryFn: fetchTargetCategoriesWithPupils,
    });

    return {
        targetCategories: data || [],
        targetCategoriesError: error,
        targetCategoriesIsLoading: isLoading,
        refetchTargetCategories: refetch,
    };
}
